const quickCategories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Single%20luxury%20designer%20sneaker%20on%20white%20marble%20surface%20with%20soft%20angled%20lighting%2C%20minimal%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20no%20text%20visible&width=400&height=300&seq=trust-shoes-v2&orientation=landscape"
  },
  {
    name: "Hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Folded%20luxury%20premium%20hoodie%20sweater%20on%20light%20oak%20wooden%20surface%2C%20natural%20window%20light%2C%20soft%20fabric%20texture%20visible%2C%20minimalist%20flat%20lay%2C%20editorial%20style%2C%20no%20text&width=400&height=300&seq=trust-hoodies-v2&orientation=landscape"
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Neatly%20folded%20designer%20cotton%20t-shirt%20on%20warm%20beige%20linen%20background%2C%20soft%20diffused%20lighting%20from%20above%2C%20clean%20minimal%20product%20photography%2C%20no%20text%20visible&width=400&height=300&seq=trust-tshirts-v2&orientation=landscape"
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20designer%20bomber%20jacket%20hanging%20on%20minimal%20wooden%20hanger%20against%20cream%20wall%2C%20soft%20natural%20light%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20no%20text&width=400&height=300&seq=trust-jackets-v2&orientation=landscape"
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20designer%20handbag%20on%20white%20pedestal%20with%20soft%20shadow%2C%20gallery%20style%20lighting%2C%20minimalist%20product%20photography%2C%20luxury%20fashion%20editorial%2C%20clean%20background%2C%20no%20text&width=400&height=300&seq=trust-bags-v2&orientation=landscape"
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20fashion%20accessories%20including%20sunglasses%20and%20watch%20arranged%20on%20light%20stone%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%20flat%20lay%2C%20minimal%20composition%2C%20no%20text&width=400&height=300&seq=trust-accessories-v2&orientation=landscape"
  },
];

export default function TrustBar() {
  const stats = [
    { value: "+5.000", label: "Produtos" },
    { value: "Diária", label: "Atualização" },
    { value: "98%", label: "Links Ativos" },
    { value: "+300", label: "Novos/semana" },
  ];

  return (
    <section id="trust" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <p className="text-center text-sm text-foreground-500 font-medium tracking-wide uppercase">
          Compre com Confiança
        </p>
        <p className="mt-6 text-center text-lg md:text-xl text-foreground-700 max-w-[720px] mx-auto leading-relaxed">
          +5.000 produtos verificados. Atualização diária. Links testados manualmente. Entrega internacional. Pagamento seguro. Comunidade ativa com mais de 10.000 usuários no Brasil. 98% dos links permanecem ativos. Mais de 300 novos produtos adicionados por semana.
        </p>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-[800px] mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-5 rounded-lg bg-background-100">
              <div className="text-2xl md:text-3xl font-bold font-heading text-primary-600">
                {stat.value}
              </div>
              <div className="mt-1 text-sm text-foreground-500 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <p className="text-center text-sm text-foreground-500 font-medium tracking-wide uppercase mb-8">
            Categorias em Destaque
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 max-w-[1100px] mx-auto">
            {quickCategories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center p-4 rounded-xl bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-200 hover:bg-background-50 transition-all duration-300"
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden mb-3">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    title={`${cat.name} - Hoobuy Spreadsheet`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-400"
                  />
                </div>
                <span className="text-xs md:text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}